var exports = {
  "kL": "SlowmodeIndicator.module__container___SFduaj",
  "K2": "SlowmodeIndicator.module__cooldown___SFduaj",
  "Pf": "SlowmodeIndicator.module__label___SFduaj",
  "Kk": "SlowmodeIndicator.module__icon___SFduaj",
};

module.exports = exports;
